import { type AnimationControlValue, AnimationRadioGroup } from './AnimationRadioGroup';
import { directionOptions, type AnimationDirection } from './animationControlOptions';

type AnimationDirectionControlProps = {
    value?: AnimationControlValue<AnimationDirection>;
    defaultValue?: AnimationControlValue<AnimationDirection>;
    onChange?: (value: AnimationControlValue<AnimationDirection>) => void;
};

const AnimationDirectionControl = (props: AnimationDirectionControlProps) => (
    <AnimationRadioGroup name='direction' options={directionOptions} {...props} />
);

export default AnimationDirectionControl;
